import parse from 'html-react-parser';
import { FormFooter, GlobalWrapper } from './style';
import { useConfigContext } from '../../../../contexts/ConfigContext';
import { useLabelsContext } from '../../../../contexts/LabelsContext';
import ErrorPage from '../../../ErrorPage';
import SignInOrchestration from '../../../LoginPilot/components/SignInOrchestration';

const SigninPage = props => {
  const { error } = useConfigContext();
  const { hideSigninFooter } = props;
  const { labels } = useLabelsContext();

  return error ? (
    <ErrorPage />
  ) : (
    <>
      <SignInOrchestration />
      {!hideSigninFooter ? (
        <FormFooter>
          <GlobalWrapper>
            {labels?.gcp_link && parse(labels.gcp_link)}
          </GlobalWrapper>
        </FormFooter>
      ) : ''}
    </>
  );
};

export default SigninPage;